import { createFileRoute, Outlet, useRouter } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { supabase } from "@/integrations/supabase/client";
import AdminLogin from "@/components/AdminLogin";

const AdminAssistant = lazy(() => import("@/components/AdminAssistant"));

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  beforeLoad: async () => {
    const { data, error } = await supabase.auth.getUser();
    return { user: error ? null : (data.user ?? null) };
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { user } = Route.useRouteContext();
  const router = useRouter();
  if (!user) return <AdminLogin onSignedIn={() => router.invalidate()} />;
  return (
    <>
      <Outlet />
      <Suspense fallback={null}>
        <AdminAssistant />
      </Suspense>
    </>
  );
}
